import { Component, ViewChild, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SituWarpApiClient, SearchArtifactsRequest, GetArtifactsResponse, MetaData, Artifact } from 'situ-warpapi-client';
import { ProductType } from 'situview-webapi-client';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {SelectionModel} from '@angular/cdk/collections';
import { ProductService } from 'src/app/services';

@Component({
  selector: 'select-artifact-dialog',
  templateUrl: './select-artifact-dialog.component.html',
  styleUrls: ['./select-artifact-dialog.component.less']
})
export class SelectArtifactDialogComponent {

  templateType?: string;

  dataSource = new MatTableDataSource<Artifact>();
  selection: SelectionModel<Artifact>;

  productTemplates?: Set<string>;

  displayedColumns = ['select', 'callerReferenceKey', 'version', 'dateAdded'];

  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  @ViewChild(MatSort) sort: MatSort | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SelectArtifactDialogData,
    private dialogRef: MatDialogRef<SelectArtifactDialogData>,
    private warpApiClient: SituWarpApiClient,
    private productService: ProductService,
  ) {
    this.selection = new SelectionModel<Artifact>(data.multiSelect, []);
    this.templateType = data.selectedTemplateName;

    this.loadProductTemplates();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator!;
    this.dataSource.sort = this.sort!;
  }
  
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource!.filter = filterValue.trim().toLowerCase();
  }

  loadData() {
    var typeMetaData = new MetaData();
    typeMetaData.key = "Type";
    typeMetaData.value = "assetinstance"

    var templateMetaData = new MetaData();
    templateMetaData.key = "Template";
    templateMetaData.value = this.templateType;

    var request = new SearchArtifactsRequest();
    request.excludeDeleted = true;
    request.includeInactive = false;
    request.returnLatestOnly= true;
    request.returnFiles = false;
    request.returnMetaData = false;
    request.returnSourceArtifacts = false;
    request.metaData = [typeMetaData, templateMetaData];

    const defaultDate = new Date(8.64e15)
    this.warpApiClient.searchArtifacts(request)
    .then((response: GetArtifactsResponse) => {
      var artifacts = response.artifacts ?? [];
      artifacts.sort((a, b) => (b.dateAdded ?? defaultDate).getTime() - (a.dateAdded ?? defaultDate).getTime())
      this.dataSource.data = artifacts;
    });
  }

  selectAssets() {
    this.dialogRef.close(this.getReturnData());
  }

  private getReturnData(): SelectArtifactResultData {
    return { 
      artifacts: this.selection.selected,
    } as SelectArtifactResultData;
  }

  private async loadProductTemplates() {
    var productTypes = await this.productService.LoadProductTypes()

    this.productTemplates = new Set(productTypes.map(x => x.templateName!));

    if (this.templateType) {
      this.loadData();
    }
  }

}

export class SelectArtifactDialogData {
  multiSelect = false;
  selectedTemplateName?: string;
}

export interface SelectArtifactResultData {
  artifacts: Artifact[];
}